import angular from 'angular';
import customCrmMultiSelect from './customCrmMultiSelect';
import groupOption from './groupOption';

export default angular
  .module('components.customCrmMultiSelect', [])
  .component('customCrmMultiSelect', customCrmMultiSelect)
  .component('groupOption', groupOption).name;
